import React from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Target, MessageSquareQuote, Activity, X, Share2 } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : "");

export function ActivityFeed({ assignments, recent, onOpenRep, onCancelled }) {
  const cancel = async (a) => {
    try { await api.delete(`/manager/assignments/${a.id}`); onCancelled(a.id); toast.success("Drill cancelled"); }
    catch { toast.error("Couldn't cancel"); }
  };
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white shadow-[0_4px_20px_-4px_rgba(15,23,42,0.06)] p-5 h-full" data-testid="activity-feed">
      <h2 className="text-lg font-bold tracking-tight text-slate-900 flex items-center gap-2"><Target className="w-5 h-5 text-rose-600" /> Open drills</h2>
      {assignments.length === 0 ? <p className="text-xs text-slate-500 mt-2">No drills assigned yet. Use the target button next to a rep.</p> : (
        <ul className="mt-3 space-y-2">
          {assignments.map((a) => (
            <li key={a.id} className="flex items-center gap-3 rounded-2xl border border-slate-200 p-2.5" data-testid={`assignment-${a.id}`}>
              <img src={a.persona_avatar} alt="" className="w-9 h-9 rounded-lg object-cover object-top" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-slate-900 truncate">{a.rep_name} → {a.persona_title}</div>
                <div className="text-xs text-slate-500">Target {a.target_score} · best so far {a.best_rating ?? "—"} · {a.attempts} attempt{a.attempts === 1 ? "" : "s"}</div>
              </div>
              <button onClick={() => cancel(a)} className="text-slate-400 hover:text-red-600" title="Cancel drill" data-testid={`assignment-cancel-${a.id}`}><X className="w-4 h-4" /></button>
            </li>
          ))}
        </ul>
      )}
      <h2 className="text-lg font-bold tracking-tight text-slate-900 flex items-center gap-2 mt-6"><Activity className="w-5 h-5 text-cyan-600" /> Latest calls</h2>
      <ul className="mt-3 divide-y divide-slate-100" data-testid="latest-calls">
        {recent.map((s) => (
          <li key={s.id} className="py-2 flex items-center gap-3">
            <img src={s.persona_avatar} alt="" className="w-8 h-8 rounded-lg object-cover object-top" />
            <button onClick={() => onOpenRep(s.user_id)} className="flex-1 min-w-0 text-left">
              <div className="text-sm text-slate-900 truncate"><strong>{s.rep_name}</strong> vs {s.persona_title}</div>
              <div className="text-xs text-slate-500 flex items-center gap-2">{fmt(s.ended_at)} · {s.channel_label}{s.has_note && <span className="inline-flex items-center gap-1 text-cyan-700"><MessageSquareQuote className="w-3 h-3" /> noted</span>}</div>
            </button>
            {s.share_id && <Link to={`/share/${s.share_id}`} className="text-slate-400 hover:text-emerald-700" title="Shared with team"><Share2 className="w-3.5 h-3.5" /></Link>}
            <span className={`text-sm font-extrabold ${s.rating >= 75 ? "text-emerald-700" : s.rating >= 50 ? "text-amber-700" : "text-red-700"}`}>{s.rating}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
